import {
  ChangeDetectionStrategy,
  Component,
  ComponentRef,
  EventEmitter,
  Input,
  Output,
  TrackByFunction
} from '@angular/core'
import { AdComponentInputs } from '../../../shared/ads/ad/ad-component.interface'
import { ContentItem } from '../../../libs/primary-related-content/primary-related-content.component'
import { Video } from '@flocasts/flosports30-types/dist/entity'
import { AdComponent } from '../../../shared/ads/ad/ad.component'
import { AdTypes } from '../../../shared/ads/advertising-service/ad-config'

type HasInstance<A> = { instance: A }

export interface ArticleView {
  title: string
  description: string
  drillThrough: null | {
    name: string
    slug_uri: string
  }
  tags: ReadonlyArray<{
    name: string
    slug_uri: string
  }> | null
  assetUrl: string
  content: string
  authorDate: null | {
    firstName: string | null
    lastName: string | null
    date: Date | null
  }
  showPaywall: boolean
  paywallMessaging?: string
  userLoggedIn: boolean
  slugUri: string
  previewContent: string
  heroVideo: Video | null
  shareableLink: string
}

@Component({
  selector: 'flo-article-view',
  templateUrl: './article-view.component.html',
  styleUrls: ['./article-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArticleViewComponent {
  @Input() public adConfigMap: Map<AdTypes, AdComponentInputs>
  @Input() public articleView: ArticleView
  @Input() public rightRailRelatedContent: ReadonlyArray<ContentItem> | null
  @Input() public belowRelatedContent: ReadonlyArray<ContentItem> | null
  @Output() public lazyLoadedAdRef = new EventEmitter<HasInstance<AdComponent>>()

  public get authorFirstName(): string | null {
    return this.articleView.authorDate?.firstName ?? null
  }

  public get authorLastName(): string | null {
    return this.articleView.authorDate?.lastName ?? null
  }

  public get publishDate(): Date | null {
    return this.articleView.authorDate?.date ?? null
  }

  public get rightRailRelatedContentTitle(): string {
    return this.articleView.drillThrough?.name !== undefined ? `More ${this.articleView.drillThrough.name}` : `Up Next`
  }

  public get rightRailContentNotEmpty(): boolean {
    if (this.rightRailRelatedContent === null) return false
    return this.rightRailRelatedContent.length > 0
  }

  public belowContentTitle = 'Related Content'

  public get belowContentNotEmpty(): boolean {
    if (this.belowRelatedContent === null) return false
    return this.belowRelatedContent.length > 0
  }

  public readonly AdComponent = import('src/app/shared/ads/ad/ad.component').then(m => m.AdComponent)

  // Lazy loaded content
  public showNewsletter = false

  public trackByContentId: TrackByFunction<ContentItem> = (index, content) => {
    return content.analytics.node_id
  }

  public readonly loadedAdsPush = (loadedAd: ComponentRef<AdComponent>): void => {
    // parent component has the adConfig, tell it which ads have loaded
    this.lazyLoadedAdRef.next(loadedAd)
  }
}
